import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ProcessChart, {
  ProcessChartValue,
} from '../../SampleAssessment/SampleAssessmentStatistics/ProcessChart.component';

interface DashboardCardProgressbar {
  rgzAlreadySent: number;
  rgzToBeSent: number;
  pzwoAlreadysent: number;
  total: number;
  totalZwo?: number;
  notStarted: boolean;
}

export const DashboardCardProgressbar: React.FC<DashboardCardProgressbar> = (props: DashboardCardProgressbar) => {
  const backgroundColorPrimary = props.total === 0 ? '#6F707B80' : '#7B62D5';

  const styledKKProgress = {
    value: 0,
    color: 'red',
  } as ProcessChartValue;

  const styledPwoProgress = {
    value: props.pzwoAlreadysent,
    color: '#3C419A',
  } as ProcessChartValue;

  const styledZwoReady = {
    value: props.rgzAlreadySent,
    color: '#347F42',
  } as ProcessChartValue;

  const styledTotal = {
    value: props.total,
    color: backgroundColorPrimary,
  } as ProcessChartValue;

  const styledTotalZwo = {
    value: props.total,
    color: '#6F707B',
  } as ProcessChartValue;

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <ProcessChart
            zwoReady={styledZwoReady}
            kkProgress={styledKKProgress}
            pzwoProgress={styledPwoProgress}
            total={props.totalZwo ? styledTotalZwo : styledTotal}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography
            sx={{ fontSize: 12, color: 'rgba(44, 45, 62, 0.8)', fontWeight: 500, marginTop: '2px' }}
            variant="body2"
            color="text.secondary"
          >{`${Math.round(props.total)}`}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
